import { Controller } from "@hotwired/stimulus";
import accessibleAutocomplete from "accessible-autocomplete";

export default class extends Controller {
  static targets = ["select"];
  static values = {
    i18n: Object,
  };

  connect() {
    // Check if select has already been enhanced to prevent duplicates on browser back navigation
    if (this.isAlreadyEnhanced()) {
      return;
    }

    accessibleAutocomplete.enhanceSelectElement({
      selectElement: this.selectTarget,
      showAllValues: true,
      placeholder: this.hasPlaceholderValue
        ? this.placeholderValue
        : this.i18nValue.placeholder,
      tNoResults: () => this.i18nValue.no_results,
      tAssistiveHint: () => this.i18nValue.assistive_hint,
    });
  }

  disconnect() {
    this.cleanup();
  }

  isAlreadyEnhanced() {
    const select = this.selectTarget;
    // Check if select ID already ends with -select (library renames it during enhancement)
    if (select.id.endsWith("-select")) {
      return true;
    }
    // Check if wrapper div already exists as a sibling
    const wrapper = select.parentElement?.querySelector(".autocomplete__wrapper");
    if (wrapper) {
      return true;
    }
    return false;
  }

  cleanup() {
    const select = this.selectTarget;
    const parent = select.parentElement;
    
    if (!parent) {
      return;
    }

    // Find and remove the wrapper div (contains the autocomplete UI)
    const wrapper = parent.querySelector(".autocomplete__wrapper");
    if (wrapper) {
      wrapper.remove();
    }

    // Find the hidden select (with -select suffix) and restore it
    // The library renames the original select by appending -select to its ID
    let hiddenSelect = null;
    
    if (select.id.endsWith("-select")) {
      // The selectTarget itself is the hidden select
      hiddenSelect = select;
    } else {
      // Look for the hidden select with -select suffix
      const hiddenSelectId = `${select.id}-select`;
      hiddenSelect = document.getElementById(hiddenSelectId);
    }
    
    if (hiddenSelect) {
      // Restore original ID (remove -select suffix)
      const originalId = hiddenSelect.id.replace(/-select$/, "");
      hiddenSelect.id = originalId;
      
      // Make it visible again
      hiddenSelect.style.display = "";
    }
  }
}
